module.exports = __webpack_public_path__ + "assets/img/card-bg-gold.28becca2.png";